import { useCallback, useContext } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useInvalidateFilesQueries } from '@/api/hooks/useInvalidateFileQueries';
import { ProjectDetailsContext } from '@/screens/Project.Main/Context';


export const useInvalidateFilesQuery = () => {
  const details = useContext(ProjectDetailsContext);
  const queryClient = useQueryClient();
  // Also invalidates the workspace's own listing, whatever workspace it is for.
  const baseInvalidateFilesQueries = useInvalidateFilesQueries();


  const invalidateProjectFiles = useCallback(() => {
    if (details) {
      return queryClient.invalidateQueries({
        queryKey: [
          `get:projects/files`,
          details.query.data.project.id,
          details.query.data.project.parentId,
        ],
      });
    }
  }, [details, queryClient]);

  return useCallback(() => {
    invalidateProjectFiles()?.catch(() => {
      // A refresh that fails leaves the list as it was; the next fetch corrects it.
    });
    baseInvalidateFilesQueries();
  }, [baseInvalidateFilesQueries, invalidateProjectFiles]);
};
